import type { ReactNode } from 'react';
import { PlainLink, type LinkComponent } from '@paige/ui';
import { TestMark } from '../TestMark';
import type { OpsCompany } from '../problems/problem-types';
import './ops.css';

/**
 * A company on an Operations screen: its name as a link to its page, and the Test mark when it is one of
 * Ademero's own, so nobody takes a load test for a customer in trouble.
 */
export function OpsCompanyName({
  company,
  href,
  Link = PlainLink,
}: {
  company: Pick<OpsCompany, 'name' | 'testCompany'>;
  href: string;
  Link?: LinkComponent | undefined;
}): ReactNode {
  return (
    <span className="ops-company">
      <Link href={href}>{company.name}</Link>
      {company.testCompany ? <TestMark /> : null}
    </span>
  );
}
